import { render, staticRenderFns } from "./media-preview-VIDEO.vue?vue&type=template&id=505ca3d8&"
import script from "./media-preview-VIDEO.vue?vue&type=script&lang=js&"
export * from "./media-preview-VIDEO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505ca3d8')) {
      api.createRecord('505ca3d8', component.options)
    } else {
      api.reload('505ca3d8', component.options)
    }
    module.hot.accept("./media-preview-VIDEO.vue?vue&type=template&id=505ca3d8&", function () {
      api.rerender('505ca3d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/media-file-preview/types/media-preview-VIDEO.vue"
export default component.exports